import {
  CreatePaymentRequest,
  CreatePaymentRequestResp,
  CreatePaymentRequestRespSchema,
  Credit,
  CreditSchema,
  CreditTxWithMeta,
  CreditTxWithMetaSchema,
  PageData,
  PageDataSchema,
  PageReq
} from "@humanex/interfaces";
import { ApiRoute, getApiRoute } from "@humanex/interfaces";

import { ApiClientConfig, BaseApiClient } from "./base-client";

export class CreditApiClient extends BaseApiClient {
  constructor(config: ApiClientConfig) {
    super({ ...config, baseEndpoint: getApiRoute(ApiRoute.CREDIT) });
  }

  // Get current user's credit balance
  async getMy(): Promise<Credit> {
    return await this.get("me", CreditSchema, { requireAuth: true });
  }

  // Get specific user's credit balance
  async getUserCredits(userId: string): Promise<Credit> {
    return await this.get(`${userId}`, CreditSchema, { requireAuth: true });
  }

  // Get current user's transaction history
  async getMyTransactions(query: PageReq = { page: 0, limit: 20 }): Promise<PageData<CreditTxWithMeta>> {
    return await this.get(`me/transactions`, PageDataSchema(CreditTxWithMetaSchema), {
      requireAuth: true,
      params: query
    });
  }

  // Get specific user's transaction history
  async getUserTransactions(
    userId: string,
    query: PageReq = { page: 0, limit: 20 }
  ): Promise<PageData<CreditTxWithMeta>> {
    return await this.get(`${userId}/transactions`, PageDataSchema(CreditTxWithMetaSchema), {
      requireAuth: true,
      params: query
    });
  }

  // Get credit price information
  async getCreditPriceInfo(): Promise<{
    pricePerCredit: number;
    currency: string;
    description: string;
  }> {
    return {
      pricePerCredit: 50000,
      currency: "VND",
      description: "Price per credit in Vietnamese Dong"
    };
  }

  // Create payment request
  async createPaymentRequest(data: CreatePaymentRequest): Promise<CreatePaymentRequestResp> {
    return await this.post("payment/create", CreatePaymentRequestRespSchema, data, {
      requireAuth: true
    });
  }
}
